import React from 'react';
import { IconProps } from './types';

const Navaids = (props: IconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 22.04 19.28"
        {...props}
    >
        <path
            fill="currentColor"
            d="M15.43 19.28H6.49v-5.19L3.86 9.57 0 7.32 4.18 0 8.1 2.28h5.84L17.86 0l4.18 7.32L18 9.66l-2.57 4.42v5.19Zm-7.44-1.5h5.94v-4.09l2.97-5.12 3.1-1.8-2.7-4.72-2.96 1.72H7.7L4.74 2.05l-2.7 4.72 2.92 1.7 3.03 5.22v4.09Zm5.29-5H8.64l-2.33-4 2.33-4h4.64l2.33 4-2.33 4Zm-3.78-1.5h2.92l1.45-2.5-1.45-2.5H9.5l-1.45 2.5 1.45 2.5Z"
        />
    </svg>
);

export default Navaids;
